import React from 'react'


const NoPageFound = () => {
  return (
    <div className='nopagefound'><h1>NoPageFound</h1>
    <h3>Click on the logo for home</h3>
 
    </div>
  )
}

export default NoPageFound